import { Menu } from "react-admin";
import { useLocation } from "react-router-dom";

import { borderRadius, color, space, typography } from "../theme/designTokens";

type Props = {
  to: string;
  primaryText: string | React.ReactNode;
  leftIcon: React.ReactElement;
  // Selected only on this exact path, not on the paths below it.
  exact?: boolean;
};

export const CustomMenuItem = ({ to, primaryText, leftIcon, exact = false }: Props) => {
  const location = useLocation();
  const isSelected = to === "/" || exact ? location.pathname === to : location.pathname.startsWith(to);

  return (
    <Menu.Item
      to={to}
      primaryText={primaryText}
      leftIcon={leftIcon}
      selected={isSelected}
      sx={{
        color: color.typographyBase,
        borderRadius: borderRadius.xs,
        fontSize: typography.fontSize.md,
        fontWeight: typography.fontWeight.medium,
        padding: space.xs,
        // react-admin marks a link active on every path below it too.
        "&.RaMenuItemLink-active": {
          backgroundColor: isSelected ? color.secondaryButtonBackground : color.transparent,
        },
      }}
    />
  );
};
